import { useContext, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import OrganizationListComponent from "./organization-list/organization-list";
import AddOrganizationComponent from "./add/add-organization";
import DeleteOrganizationComponent from "./delete/delete-organization";
import Box from "@mui/material/Box";
import {EditOrganizationDialog, EditOrganizationComponent} from "./edit/edit-organization";
import {
  OrganizationsContext,
  OrganizationsProvider,
} from "./organizations-context";
import pubSub, { EVENTS } from "../../config/pubSub"; 

const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 1),
  height: "100%",
}));

const StyledContent = styled(Box)(({ theme }) => ({
  maxWidth: "100%",
  padding: theme.spacing(4),
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: "400px",
  borderRadius: "10px",
  boxShadow: "0px 3px 15px #00000029",
  [theme.breakpoints.between("xs", "sm")]: {
    maxWidth: "300px",
  },
  [theme.breakpoints.between("sm", "md")]: {
    maxWidth: "500px",
  },
  [theme.breakpoints.between("md", "lg")]: {
    maxWidth: "750px",
  },
  [theme.breakpoints.between("lg", "xl")]: {
    maxWidth: "1175px",
  },
  [theme.breakpoints.up("xl")]: {
    maxWidth: "100%",
  },
}));

const StyledToolbar = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 0, 3, 0),
}));

const OrganizationsListPage = () => {
  const {
    orgListTab
  } = useContext(OrganizationsContext);
  const { t } = useTranslation();

  const renderTab = () => {
    return <OrganizationListComponent statusFilter={orgListTab} />;
  };

  return (
    <StyledContainer display="flex" flexDirection="column">
      <StyledContent>
        <header style={{ marginBottom: 15 }}>
          <Typography variant="h4">{t("page_organization_title")}</Typography>
        </header>

        <StyledToolbar display="flex" flexDirection="row" alignItems="baseline">
      
            <AddOrganizationComponent />
            <EditOrganizationComponent />
            <DeleteOrganizationComponent />
        </StyledToolbar>

        {renderTab()}
      </StyledContent>
    </StyledContainer>
  );
};

const OrganizationsPage = () => {
  const { selectedOrg, setSelectedOrg, setSelectedCheckedOrgs } = useContext(OrganizationsContext);
  const [openEditDialog, setOpenEditDialog] = useState(false); 

  useEffect(() => {
    // Update openEditDialog whenever selectedOrg changes
    const isEditEnabled = !!selectedOrg && selectedOrg.split(",").length === 1;
    setOpenEditDialog(isEditEnabled);
  }, [selectedOrg]);

  const handleCloseEdit = () => {
    setOpenEditDialog(false);
    setSelectedOrg(null);
    setSelectedCheckedOrgs([]);
  };

  const handleEditDone = () => {
    setOpenEditDialog(false);
    setSelectedOrg(null);
    setSelectedCheckedOrgs([]);
    pubSub.publish(EVENTS.ORGANIZATIONS_LIST);
  };

  return (
    <OrganizationsProvider>
      <Box display="flex" flexDirection="column">
        <OrganizationsListPage  />
        {selectedOrg && ( 
          <EditOrganizationDialog
            open={openEditDialog}
            selectedOrg={selectedOrg}
            handleEditOrganizationClose={handleCloseEdit}
            handleEditOrganizationDone={handleEditDone}
          />
        )}
      </Box>
    </OrganizationsProvider>
  );
};

export default OrganizationsPage;
